import axiosClient from "..";
import {
  GET_ALL_REPORTS_URL,
  GET_CLIENT_EXPENSE_REPORT_URL,
  GET_CLOSED_REPORTS_URL,
  GET_EXCEPTIONS_REPORT_URL,
  GET_INITIATION_REPORTS_URL,
  GET_FAVOURITE_LIST,
  GET_FAV_DASHBOARD_DATA,
  GET_CLIENT_EXPENSE_BY_CATEGORY_URL,
  VENDOR_TRACKING_MOVE_HELP,
  GET_SUBMITTED_EXPENSE_REPORT,
  GET_TLR_REPORTS,
  GET_TLO_REPORTS,
  GET_EXCEPTION_REQUEST_REPORT,
} from "../../resources/constants";
import { saveAs } from "file-saver";
import axios from "axios";

const getFilterParamsAndBody = (filtersData: any) => {
  let filters = { ...filtersData };
  const params = new URLSearchParams({
    page: filters.page,
    limit: filters.limit,
    order: filters.order,
  }).toString();
  delete filters.page;
  delete filters.limit;
  delete filters.order;
  return { params, body: filters };
};
class ReportsService {
  public static async getAllReports(filters: any) {
    try {
      let filtersCopy = { ...filters };
      const params = new URLSearchParams({
        page: filtersCopy?.page || 1,
        limit: filtersCopy.limit || 10,
        order: filtersCopy.order || "ASC",
        clientId: filtersCopy.clientId,
      }).toString();
      const { data }: { data: any } = await axiosClient.get(
        GET_ALL_REPORTS_URL + "?" + params,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getClosedReports(filters: any) {
    return {
      data: [
        {
          initDate: "2022-07-07T18:12:56.487Z",
          policy: "AkzoNobel Renter Program",
          date: "2022-11-14T18:35:33.980Z",
          orgUid: 1987,
          status: "CLOSED",
          "Cust Div": 1987,
          firstName: "Stephanie",
          lastName: "Samson",
          fileNumber: "217-01097",
          orgName: "AkzoNobel- Wood Coatings",
          originCity: "Durham",
          originState: "NC    ",
          originCountry: "USA   ",
          destinationCity: "High Point",
          destinationState: "NC    ",
          destinationCountry: "USA   ",
          totalAmount: 7854.03,
        },
        {
          initDate: "2022-06-22T20:34:38.410Z",
          policy: "AkzoNobel - Rotational Program (101-500)",
          date: "2022-10-06T15:37:36.180Z",
          orgUid: 1983,
          status: "CLOSED",
          "Cust Div": 1983,
          firstName: "Stacey",
          lastName: "Jones",
          fileNumber: "217-01093",
          orgName: "AkzoNobel- Metal Coatings",
          originCity: "Wadsworth",
          originState: "IL    ",
          originCountry: "USA   ",
          destinationCity: "Columbus",
          destinationState: "OH    ",
          destinationCountry: "USA   ",
          totalAmount: 4445,
        },
        {
          initDate: "2022-06-15T16:51:44.810Z",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          date: "2022-10-06T15:32:06.100Z",
          orgUid: 1984,
          status: "CLOSED",
          "Cust Div": 1984,
          firstName: "Joaquin",
          lastName: "Lopez",
          fileNumber: "217-01091",
          orgName: "AkzoNobel- Powder Coatings",
          originCity: "Smyrna",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Tampa",
          destinationState: "FL    ",
          destinationCountry: "USA   ",
          totalAmount: 32532.3,
        },
        {
          initDate: "2022-06-02T16:36:50.040Z",
          policy: "AkzoNobel Renter Program",
          date: "2022-10-06T15:07:09.043Z",
          orgUid: 1984,
          status: "CLOSED",
          "Cust Div": 1984,
          firstName: "Joelen",
          lastName: "Lima",
          fileNumber: "217-01089",
          orgName: "AkzoNobel- Powder Coatings",
          originCity: "Long Beach",
          originState: "CA    ",
          originCountry: "USA   ",
          destinationCity: "Austin",
          destinationState: "TX    ",
          destinationCountry: "USA   ",
          totalAmount: 40845.03,
        },
        {
          initDate: "2022-04-28T17:29:55.810Z",
          policy: "AkzoNobel Renter Program",
          date: "2022-10-06T14:35:15.250Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Noah",
          lastName: "Elias-Guy",
          fileNumber: "217-01084",
          orgName: "AkzoNobel",
          originCity: "West Newbury",
          originState: "MA    ",
          originCountry: "USA   ",
          destinationCity: "Huron",
          destinationState: "OH    ",
          destinationCountry: "USA   ",
          totalAmount: 16865.37,
        },
        {
          initDate: "2022-04-27T20:04:55.420Z",
          policy: "AkzoNobel Renter Program",
          date: "2022-10-06T14:21:13.507Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Bailey",
          lastName: "Clark",
          fileNumber: "217-01083",
          orgName: "AkzoNobel",
          originCity: "Tallahassee",
          originState: "FL    ",
          originCountry: "USA   ",
          destinationCity: "Pontiac",
          destinationState: "MI    ",
          destinationCountry: "USA   ",
          totalAmount: 14621.63,
        },
        {
          initDate: "2022-03-16T21:01:13.517Z",
          policy: "Demo",
          date: "2022-10-06T13:26:19.230Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Shawn",
          lastName: "Saddleson",
          fileNumber: "217-01071",
          orgName: "AkzoNobel",
          originCity: "Orchard Park",
          originState: "NY    ",
          originCountry: "USA   ",
          destinationCity: "Nashville",
          destinationState: "TN    ",
          destinationCountry: "USA   ",
          totalAmount: 121966.53,
        },
        {
          initDate: "2022-02-28T17:39:11.593Z",
          policy: "AkzoNobel Homeowner Tier 1 Program (Lump Sum)",
          date: "2022-10-06T12:58:59.777Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Karen",
          lastName: "Kukla",
          fileNumber: "217-01065",
          orgName: "AkzoNobel",
          originCity: "Lowell",
          originState: "MI    ",
          originCountry: "USA   ",
          destinationCity: "Monterey",
          destinationState: "TN    ",
          destinationCountry: "USA   ",
          totalAmount: 55303.33,
        },
        {
          initDate: "2022-02-16T17:41:49.270Z",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          date: "2022-10-06T12:55:49.977Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Harleigh",
          lastName: "Huggins",
          fileNumber: "217-01063",
          orgName: "AkzoNobel",
          originCity: "Memphis",
          originState: "TN    ",
          originCountry: "USA   ",
          destinationCity: "Nashville",
          destinationState: "TN    ",
          destinationCountry: "USA   ",
          totalAmount: 51265.16,
        },
        {
          initDate: "2022-08-11T19:56:13.147Z",
          policy: "AkzoNobel Renter Program",
          date: "2022-10-06T12:51:22.863Z",
          orgUid: 217,
          status: "CLOSED",
          "Cust Div": 217,
          firstName: "Sam",
          lastName: "Breeden",
          fileNumber: "217-01103",
          orgName: "AkzoNobel",
          originCity: "Gulfport",
          originState: "MS    ",
          originCountry: "USA   ",
          destinationCity: "Rock Hill",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 13310.84,
        },
      ],
      count: 135,
      status: {
        ACTIVE: "ACTIVE",
        CANCEL: "CANCEL",
        CLOSED: "CLOSED",
        OFFHLD: "OFFHLD",
        ONHOLD: "ONHOLD",
      },
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_CLOSED_REPORTS_URL + "?" + params,
        body,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getInitiationReports(filters: any) {
    return {
      data: [
        {
          fileNumber: "217-01113",
          date: "2024-07-09T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Active",
          policy: "AkzoNobel Renter Program",
          firstName: "Beth",
          lastName: "Fox",
          originCity: "Atlanta",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Atlanta",
          destinationState: "GA    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01109",
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Active",
          policy: "AkzoNobel - Rotational Program (500+)",
          firstName: "Brian",
          lastName: "Nkenke",
          originCity: "Lancaster ",
          originState: "SC    ",
          originCountry: "USA   ",
          destinationCity: "Houston ",
          destinationState: "TX    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01108",
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Active",
          policy: "AkzoNobel - Rotational Program (500+)",
          firstName: "Audrey",
          lastName: "Tan",
          originCity: "Houston",
          originState: "TX    ",
          originCountry: "USA   ",
          destinationCity: "Waukegan",
          destinationState: "IL    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01111",
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Active",
          policy: "AkzoNobel - Rotational Program (500+)",
          firstName: "John",
          lastName: "Payne",
          originCity: "High Point ",
          originState: "NC    ",
          originCountry: "USA   ",
          destinationCity: "Salem",
          destinationState: "OR    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01110",
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Active",
          policy: "AkzoNobel - Rotational Program (500+)",
          firstName: "Matthew",
          lastName: "Ebanks",
          originCity: "High Point",
          originState: "NC    ",
          originCountry: "USA   ",
          destinationCity: "Warsaw",
          destinationState: "IN    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01107",
          date: "2022-10-24T00:00:00.000Z",
          divisionName: "AkzoNobel- Marine Coatings",
          status: "Active",
          policy: "AkzoNobel Renter Program",
          firstName: "Daniel",
          lastName: "Rheeder",
          originCity: "Houston",
          originState: "TX    ",
          originCountry: "USA   ",
          destinationCity: "Edmonton",
          destinationState: "AB    ",
          destinationCountry: "CAN   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01106",
          date: "2022-10-18T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "AkzoNobel -  Ad Hoc Program - SEE NOTES SECTION",
          firstName: "Garold",
          lastName: "Morgan",
          originCity: "Cossville",
          originState: "TN    ",
          originCountry: "USA   ",
          destinationCity: "Turkey Creek",
          destinationState: "KY    ",
          destinationCountry: "USA   ",
          totalAmount: 1650,
        },
        {
          fileNumber: "217-01105",
          date: "2022-09-16T00:00:00.000Z",
          divisionName: "AkzoNobel- Marine Coatings",
          status: "Active",
          policy: "AkzoNobel Canadian Homeowner Tier 2 Program (BVO)",
          firstName: "Brittany",
          lastName: "Kavanagh",
          originCity: "Alberta",
          originState: "BC    ",
          originCountry: "CAN   ",
          destinationCity: "Houston",
          destinationState: "TX    ",
          destinationCountry: "USA   ",
          totalAmount: 0,
        },
        {
          fileNumber: "217-01104",
          date: "2022-09-12T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          firstName: "Benjamin",
          lastName: "Davis",
          originCity: "New Lenox",
          originState: "IL    ",
          originCountry: "USA   ",
          destinationCity: "San Diego",
          destinationState: "CA    ",
          destinationCountry: "USA   ",
          totalAmount: 8941.05,
        },
        {
          fileNumber: "217-01103",
          date: "2022-08-11T00:00:00.000Z",
          divisionName: "AkzoNobel",
          status: "Closed",
          policy: "AkzoNobel Renter Program",
          firstName: "Sam",
          lastName: "Breeden",
          originCity: "Gulfport",
          originState: "MS    ",
          originCountry: "USA   ",
          destinationCity: "Rock Hill",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 13358.1,
        },
      ],
      count: 10,
      status: {
        ACTIVE: "Active",
        ONHOLD: "On Hold",
        CLOSED: "Closed",
        CANCELLED: "Cancelled",
      },
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_INITIATION_REPORTS_URL + "?" + params,
        filters,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getExceptionReports(filters: any) {
    return {
      data: [
        {
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 99.8,
        },
        {
          date: "2022-11-16T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 11.65,
        },
        {
          date: "2022-11-09T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 12.42,
        },
        {
          date: "2022-11-09T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 7.47,
        },
        {
          date: "2022-11-09T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 25.97,
        },
        {
          date: "2022-11-07T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 16.73,
        },
        {
          date: "2022-11-07T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 6.55,
        },
        {
          date: "2022-11-07T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 20.42,
        },
        {
          date: "2022-11-07T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 12.86,
        },
        {
          date: "2022-11-07T00:00:00.000Z",
          divisionName: "AkzoNobel- Performance Coatings",
          status: "Active",
          policy: "Demo",
          firstName: "Christian",
          lastName: "Pogson",
          originCity: "Martinez",
          originState: "GA    ",
          originCountry: "USA   ",
          destinationCity: "Lancaster",
          destinationState: "SC    ",
          destinationCountry: "USA   ",
          totalAmount: 13.18,
        },
      ],
      count: 10,
      status: {
        ACTIVE: "Active",
        ONHOLD: "On Hold",
        CLOSED: "Closed",
        CANCELLED: "Cancelled",
      },
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_EXCEPTIONS_REPORT_URL + "?" + params,
        filters,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getClientExpenseReports(filters: any) {
    return {
      data: [
        {
          totalAmount: 95,
          serv_status_dt: null,
          acct_parent_uid: 213,
          policy: "6660| Lump Sum",
          firstName: "Lucinda",
          lastName: "WIlliams",
          initDate: "2025-07-15T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00044",
          status: "ACTIVE",
          date: "2025-07-15T13:53:03.400Z",
          categoryName: "Cash",
        },
        {
          totalAmount: 250,
          serv_status_dt: null,
          acct_parent_uid: 605,
          policy: "6660| Full Service Homeowner",
          firstName: "Fiona",
          lastName: "Carpenter",
          initDate: "2025-02-13T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00043",
          status: "ACTIVE",
          date: "2025-02-24T00:00:00.000Z",
          categoryName: "Home Finding - Parent Account",
        },
        {
          totalAmount: 1100,
          serv_status_dt: null,
          acct_parent_uid: 605,
          policy: "6660| Full Service Homeowner",
          firstName: "Rick",
          lastName: "Deckard",
          initDate: "2023-10-24T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00010",
          status: "ACTIVE",
          date: "2025-01-30T00:00:00.000Z",
          categoryName: "Home Finding - Parent Account",
        },
        {
          totalAmount: 250,
          serv_status_dt: null,
          acct_parent_uid: 605,
          policy: "6660| Lump Sum",
          firstName: "Indy",
          lastName: "Fox",
          initDate: "2024-05-28T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00030",
          status: "ACTIVE",
          date: "2025-01-16T00:00:00.000Z",
          categoryName: "Home Finding - Parent Account",
        },
        {
          totalAmount: 95,
          serv_status_dt: null,
          acct_parent_uid: 213,
          policy: "6660| Lump Sum",
          firstName: "BIll",
          lastName: "Murray",
          initDate: "2024-12-31T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00041",
          status: "ACTIVE",
          date: "2024-12-31T14:00:03.327Z",
          categoryName: "Cash",
        },
        {
          totalAmount: 95,
          serv_status_dt: null,
          acct_parent_uid: 213,
          policy: "6660| Lump Sum",
          firstName: "Beth",
          lastName: "Fox2",
          initDate: "2024-12-30T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00040",
          status: "ACTIVE",
          date: "2024-12-30T17:03:02.827Z",
          categoryName: "Cash",
        },
        {
          totalAmount: 95,
          serv_status_dt: null,
          acct_parent_uid: 213,
          policy: "6660| Lump Sum",
          firstName: "Paul",
          lastName: "Smith",
          initDate: "2024-10-02T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00038",
          status: "ACTIVE",
          date: "2024-10-02T15:30:04.913Z",
          categoryName: "Cash",
        },
        {
          totalAmount: 700,
          serv_status_dt: null,
          acct_parent_uid: 607,
          policy: "6660| Lump Sum",
          firstName: "Indy",
          lastName: "Fox",
          initDate: "2024-05-28T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00030",
          status: "ACTIVE",
          date: "2024-09-17T00:00:00.000Z",
          categoryName: "Cultural Training - Parent Account",
        },
        {
          totalAmount: 600,
          serv_status_dt: null,
          acct_parent_uid: 603,
          policy: "6660| Lump Sum",
          firstName: "Indy",
          lastName: "Fox",
          initDate: "2024-05-28T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00030",
          status: "ACTIVE",
          date: "2024-09-17T00:00:00.000Z",
          categoryName: "Final Move- Parent Acount",
        },
        {
          totalAmount: 1,
          serv_status_dt: null,
          acct_parent_uid: 605,
          policy: "6660| Lump Sum",
          firstName: "Indy",
          lastName: "Fox",
          initDate: "2024-05-28T00:00:00.000Z",
          divisionName: "3.0 Client",
          fileNumber: "6660-00030",
          status: "ACTIVE",
          date: "2024-09-17T00:00:00.000Z",
          categoryName: "Home Finding - Parent Account",
        },
      ],
      count: 10,
      status: {
        ACTIVE: "ACTIVE",
        CANCEL: "CANCEL",
        CLOSED: "CLOSED",
        OFFHLD: "OFFHLD",
        ONHOLD: "ONHOLD",
      },
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_CLIENT_EXPENSE_REPORT_URL + "?" + params,
        body,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getTlrReports(filters: any) {
    return {
      report: [
        {
          "TLR ID": "1728",
          "Transferee Name": "Gruber, Hans",
          "File Number": "6673-00005",
          "Client ID": "220",
          "Client Name": "Client2",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Policy1",
          "Policy ID": "382",
          "TLR Date": "2025-06-10T18:30:00.000Z",
          "Requested City": "Bengaluru",
          "Requested State": "Karnataka",
          "Requested Country": "India",
          "TLR Status": "OPEN",
          "Shown TLOs": 1,
        },
        {
          "TLR ID": "1725",
          "Transferee Name": "Powell, Al",
          "File Number": "6673-00009",
          "Client ID": "220",
          "Client Name": "Client2",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Policy1",
          "Policy ID": "382",
          "TLR Date": "2025-06-10T18:30:00.000Z",
          "Requested City": "Bengaluru",
          "Requested State": "Karnataka",
          "Requested Country": "India",
          "TLR Status": "OPEN",
          "Shown TLOs": 4,
        },
        {
          "TLR ID": "1730",
          "Transferee Name": "Nord Hold, Gunilla",
          "File Number": "217-00044",
          "Client ID": "4",
          "Client Name": "AkzoNobel",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Canadian Homeowner Tier 3",
          "Policy ID": "236",
          "TLR Date": "2025-06-05T18:30:00.000Z",
          "Requested City": "Bengaluru",
          "Requested State": "Karnataka",
          "Requested Country": "India",
          "TLR Status": "OPEN",
          "Shown TLOs": 2,
        },
        {
          "TLR ID": "1731",
          "Transferee Name": "qa 112, Test",
          "File Number": "6667-00201",
          "Client ID": "200",
          "Client Name": "Demo Client",
          "Consultant Name": "madhushree KC",
          "Consultant ID": "4938",
          "Policy Name": "US Domestic Homeowner",
          "Policy ID": "295",
          "TLR Date": "2025-06-10T18:30:00.000Z",
          "Requested City": "Bengaluru",
          "Requested State": "Karnataka",
          "Requested Country": "India",
          "TLR Status": "OPEN",
          "Shown TLOs": 1,
        },
        {
          "TLR ID": "1726",
          "Transferee Name": "Gennaro-McClane, Holly",
          "File Number": "6673-00007",
          "Client ID": "220",
          "Client Name": "Client2",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Policy1",
          "Policy ID": "382",
          "TLR Date": "2025-06-04T18:30:00.000Z",
          "Requested City": "Ashkāsham",
          "Requested State": "Badakhshan",
          "Requested Country": "Afghanistan",
          "TLR Status": "CLOSED",
          "Shown TLOs": 2,
        },
        {
          "TLR ID": "1729",
          "Transferee Name": "Poduval, Akshay",
          "File Number": "2646-00061",
          "Client ID": "1",
          "Client Name": "Sample Corp.",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Sample Policy A",
          "Policy ID": "220",
          "TLR Date": "2025-06-04T18:30:00.000Z",
          "Requested City": "Abbeville",
          "Requested State": "Alabama",
          "Requested Country": "United States",
          "TLR Status": "CLOSED",
          "Shown TLOs": 1,
        },
        {
          "TLR ID": "1727",
          "Transferee Name": "McClane, John",
          "File Number": "6673-00006",
          "Client ID": "220",
          "Client Name": "Client2",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Policy1",
          "Policy ID": "382",
          "TLR Date": "2025-06-09T18:30:00.000Z",
          "Requested City": "Hyderabad",
          "Requested State": "Telangana",
          "Requested Country": "India",
          "TLR Status": "CLOSED",
          "Shown TLOs": 2,
        },
        {
          "TLR ID": "1722",
          "Transferee Name": "EE 1, JRS ",
          "File Number": "9854-65554",
          "Client ID": "217",
          "Client Name": "JRS developers",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Policy for JRS 11",
          "Policy ID": "372",
          "TLR Date": "2024-05-25T10:51:57.000Z",
          "Requested City": "Bangalore Urban",
          "Requested State": "Karnataka",
          "Requested Country": "India",
          "TLR Status": "CLOSED",
          "Shown TLOs": 3,
        },
        {
          "TLR ID": "1724",
          "Transferee Name": "Test 55, QA",
          "File Number": "4875-54321",
          "Client ID": "216",
          "Client Name": "LNT Enterprises",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "Adhoc policy",
          "Policy ID": "379",
          "TLR Date": "2024-06-03T07:39:23.000Z",
          "Requested City": "Amguri",
          "Requested State": "Assam",
          "Requested Country": "India",
          "TLR Status": "CLOSED",
          "Shown TLOs": 0,
        },
        {
          "TLR ID": "1723",
          "Transferee Name": "Karl, Sdin",
          "File Number": "4091-6042",
          "Client ID": "219",
          "Client Name": "Starley mels",
          "Consultant Name": "Malen mats",
          "Consultant ID": "5306",
          "Policy Name": "SS demo policy",
          "Policy ID": "376",
          "TLR Date": "2024-05-21T17:33:00.000Z",
          "Requested City": "Banswada",
          "Requested State": "Telangana",
          "Requested Country": "India",
          "TLR Status": "CLOSED",
          "Shown TLOs": 1,
        },
      ],
      tlrCount: 1283,
    };
    try {
      const { data }: { data: any } = await axiosClient.post(
        GET_TLR_REPORTS,
        filters,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getTloReports(filters: any) {
    return {
      report: [
        {
          "TLO ID": "8",
          "Property Name": "The Jane",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "110",
          "Date Added": null,
        },
        {
          "TLO ID": "19",
          "Property Name": "Gramercy of Buckhead",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "110",
          "Date Added": null,
        },
        {
          "TLO ID": "20",
          "Property Name": "The Residence Buckhead",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "133",
          "Date Added": "2019-04-16T15:11:58.000Z",
        },
        {
          "TLO ID": "21",
          "Property Name": "AMLI 3464",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "179",
          "Date Added": "2019-04-16T15:11:54.000Z",
        },
        {
          "TLO ID": "23",
          "Property Name": "935M",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "128",
          "Date Added": null,
        },
        {
          "TLO ID": "25",
          "Property Name": "131 Ponce",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "110",
          "Date Added": null,
        },
        {
          "TLO ID": "26",
          "Property Name": "Skyhouse South",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "SIGNED",
          "Price Per Night": "120",
          "Date Added": null,
        },
        {
          "TLO ID": "27",
          "Property Name": "AMLI Old 4th Ward",
          City: "Atlanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "129",
          "Date Added": null,
        },
        {
          "TLO ID": "28",
          "Property Name": "Highland Walk",
          City: "Altanta",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "129",
          "Date Added": null,
        },
        {
          "TLO ID": "30",
          "Property Name": "Hampton Inn Columbus-Airport",
          City: "Columbus",
          State: "Georgia",
          Country: "United States",
          "TLO Status": "NONE",
          "Price Per Night": "131",
          "Date Added": null,
        },
      ],
      count: 5639,
    };
    try {
      const { data }: { data: any } = await axiosClient.post(
        GET_TLO_REPORTS,
        filters,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getClientExpenseByCategory(filters: any) {
    return {
      data: [
        {
          firstName: "Beth",
          lastName: "Fox",
          date: "2024-07-09T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "ACTIVE",
          service: "Fee",
          totalAmount: 445,
        },
        {
          firstName: "Daniel",
          lastName: "Rheeder",
          date: "2022-10-24T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "ACTIVE",
          service: "Fee",
          totalAmount: 445,
        },
        {
          firstName: "Garold",
          lastName: "Morgan",
          date: "2022-10-18T00:00:00.000Z",
          policy: "AkzoNobel -  Ad Hoc Program - SEE NOTES SECTION",
          status: "ACTIVE",
          service: "Tenancy Management",
          totalAmount: 2095,
        },
        {
          firstName: "Brittany",
          lastName: "Kavanagh",
          date: "2022-09-16T00:00:00.000Z",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          status: "ACTIVE",
          service: "Fee",
          totalAmount: 970,
        },
        {
          firstName: "Benjamin",
          lastName: "Davis",
          date: "2022-09-12T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "ACTIVE",
          service: "Others",
          totalAmount: 6873.05,
        },
        {
          firstName: "Sam",
          lastName: "Breeden",
          date: "2022-08-11T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "CLOSED",
          service: "Temporary Living ",
          totalAmount: 13310.84,
        },
        {
          firstName: "Bradley",
          lastName: "Arnold",
          date: "2022-07-27T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "CANCEL",
          service: "Fee",
          totalAmount: 445,
        },
        {
          firstName: "Alma",
          lastName: "Rodriguez",
          date: "2022-07-20T00:00:00.000Z",
          policy: "AkzoNobel Renter Program",
          status: "CANCEL",
          service: "Fee",
          totalAmount: 445,
        },
        {
          firstName: "Minghang",
          lastName: "Chen",
          date: "2022-07-19T00:00:00.000Z",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          status: "ACTIVE",
          service: "Temporary Living ",
          totalAmount: 45524.29,
        },
        {
          firstName: "Jonathan",
          lastName: "Chiu",
          date: "2022-07-15T00:00:00.000Z",
          policy: "AkzoNobel Homeowner Tier 2 Program (BVO)",
          status: "ACTIVE",
          service: "Others",
          totalAmount: 78832.64,
        },
      ],
      count: 10,
      status: {
        ACTIVE: "ACTIVE",
        CANCEL: "CANCEL",
        CLOSED: "CLOSED",
        OFFHLD: "OFFHLD",
        ONHOLD: "ONHOLD",
      },
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_CLIENT_EXPENSE_BY_CATEGORY_URL + "?" + params,
        body,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getSubmittedExepnse(filters: any) {
    return {
      selectedReports: [
        {
          id: "146",
          clientName: "LNT Enterprises",
          clientContact: "kamaj, Nitish",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "SUBMITTED",
          accountManagerResp: "Submitted",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2025-02-12T16:55:50.000Z",
          amount: 1234,
          requestDtls: "tre",
          reason: "rfr",
          currentPolicyAllows: "eef",
          statusDate: "2025-02-12T16:55:50.000Z",
          expenseType: "Destination Services",
          expenseCategory: "Home Finding",
          dateCreated: "2025-02-12T16:55:50.000Z",
          osrRecommendations: "QWERTY",
        },
        {
          id: "145",
          clientName: "LNT Enterprises",
          clientContact: "",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "APPROVED",
          accountManagerResp: "Approved",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-10-24T05:59:02.000Z",
          amount: 0,
          requestDtls: "asdf",
          reason: "asd",
          currentPolicyAllows: "asdfa",
          statusDate: "2024-10-24T05:59:02.000Z",
          expenseType: "hhhh edited",
          expenseCategory: "Home Finding",
          dateCreated: "2024-10-24T05:59:02.000Z",
          osrRecommendations: "asdf",
        },
        {
          id: "144",
          clientName: "LNT Enterprises",
          clientContact: "",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "APPROVED",
          accountManagerResp: "Approved",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-18T10:18:13.000Z",
          amount: 5000,
          requestDtls: "Need more budget",
          reason: "Travelling charges",
          currentPolicyAllows: "allow",
          statusDate: "2024-06-18T10:18:13.000Z",
          expenseType: "Insurance",
          expenseCategory: "Duplicate Housing",
          dateCreated: "2024-06-18T10:00:03.000Z",
          osrRecommendations: "Yes",
        },
        {
          id: "143",
          clientName: "3.0 Client",
          clientContact: "",
          accountManager: "Manager, Account",
          transferee: "Fox, Indy",
          policyName: "Test",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-13T15:13:51.000Z",
          amount: 0,
          requestDtls: "flight home",
          reason: "He needs to go home",
          currentPolicyAllows: "no flight",
          statusDate: "2024-06-13T15:13:51.000Z",
          expenseType: "Airfare",
          expenseCategory: "Return Trips Home",
          dateCreated: "2024-06-13T15:13:51.000Z",
          osrRecommendations: "do it",
        },
        {
          id: "142",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "test, test",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "SUBMITTED",
          accountManagerResp: "Submitted",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:35:05.000Z",
          amount: 0,
          requestDtls: "dses",
          reason: "tft",
          currentPolicyAllows: "tdtd",
          statusDate: "2024-06-12T13:35:05.000Z",
          expenseType: "Allowance",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:35:05.000Z",
          osrRecommendations: "tdt",
        },
        {
          id: "141",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "SAVED",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:34:35.000Z",
          amount: 0,
          requestDtls: "tdtdtd",
          reason: "gytfyfy",
          currentPolicyAllows: "yhfyhfy",
          statusDate: "2024-06-12T13:34:35.000Z",
          expenseType: "Allowance",
          expenseCategory: "Final Move",
          dateCreated: "2024-06-12T13:34:35.000Z",
          osrRecommendations: "yfyf",
        },
        {
          id: "140",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:34:04.000Z",
          amount: 0,
          requestDtls: "yrgeyrg",
          reason: "uhgur",
          currentPolicyAllows: "hfuegf",
          statusDate: "2024-06-12T13:34:04.000Z",
          expenseType: "bsnffiv2",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:34:04.000Z",
          osrRecommendations: "jhgur",
        },
        {
          id: "139",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:33:20.000Z",
          amount: 0,
          requestDtls: "Need more budget",
          reason: "travelling charges",
          currentPolicyAllows: "allow",
          statusDate: "2024-06-12T13:33:20.000Z",
          expenseType: "Allowance",
          expenseCategory: "Final Move",
          dateCreated: "2024-06-12T13:33:20.000Z",
          osrRecommendations: "Yes",
        },
        {
          id: "138",
          clientName: "LNT Enterprises",
          clientContact: "Shak, Shaheel",
          accountManager: "Wills, Jacks",
          transferee: "Test 55, QA",
          policyName: "Adhoc policy",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:01:22.000Z",
          amount: 0.12334455588966887,
          requestDtls: "need more budget",
          reason: "traveling charges",
          currentPolicyAllows: "Allow",
          statusDate: "2024-06-12T13:01:22.000Z",
          expenseType: "Allowance",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:01:22.000Z",
          osrRecommendations: "yes",
        },
        {
          id: "137",
          clientName: "Demo Client",
          clientContact: "Collins, Hannah",
          accountManager: "Demo 112, Testing",
          transferee: "Bolognia, Brock",
          policyName: "Commuter",
          status: "SAVED",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T12:27:19.000Z",
          amount: 189,
          requestDtls: "data",
          reason: "test",
          currentPolicyAllows: "test",
          statusDate: "2024-06-12T12:27:19.000Z",
          expenseType: "Inspections (Not in Closing)",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T12:26:58.000Z",
          osrRecommendations: "test",
        },
      ],
      count: 145,
      exceptionStatusList: [
        "PENDING",
        "SAVED",
        "SUBMITTED",
        "APPROVED",
        "DENIED",
        "PROCESSED",
        "HOLD",
        "REVIEW",
      ],
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_SUBMITTED_EXPENSE_REPORT + "?" + params,
        body,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async getExceptionRequest(filters: any) {
    return {
      selectedReports: [
        {
          id: "146",
          clientName: "LNT Enterprises",
          clientContact: "kamaj, Nitish",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "SUBMITTED",
          accountManagerResp: "Submitted",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2025-02-12T16:55:50.000Z",
          amount: 1234,
          requestDtls: "tre",
          reason: "rfr",
          currentPolicyAllows: "eef",
          statusDate: "2025-02-12T16:55:50.000Z",
          expenseType: "Destination Services",
          expenseCategory: "Home Finding",
          dateCreated: "2025-02-12T16:55:50.000Z",
          osrRecommendations: "QWERTY",
        },
        {
          id: "145",
          clientName: "LNT Enterprises",
          clientContact: "",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "APPROVED",
          accountManagerResp: "Approved",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-10-24T05:59:02.000Z",
          amount: 0,
          requestDtls: "asdf",
          reason: "asd",
          currentPolicyAllows: "asdfa",
          statusDate: "2024-10-24T05:59:02.000Z",
          expenseType: "hhhh edited",
          expenseCategory: "Home Finding",
          dateCreated: "2024-10-24T05:59:02.000Z",
          osrRecommendations: "asdf",
        },
        {
          id: "144",
          clientName: "LNT Enterprises",
          clientContact: "",
          accountManager: "Wills, Jacks",
          transferee: "User 99, Test",
          policyName: "Policy for EMP 11",
          status: "APPROVED",
          accountManagerResp: "Approved",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-18T10:18:13.000Z",
          amount: 5000,
          requestDtls: "Need more budget",
          reason: "Travelling charges",
          currentPolicyAllows: "allow",
          statusDate: "2024-06-18T10:18:13.000Z",
          expenseType: "Insurance",
          expenseCategory: "Duplicate Housing",
          dateCreated: "2024-06-18T10:00:03.000Z",
          osrRecommendations: "Yes",
        },
        {
          id: "143",
          clientName: "3.0 Client",
          clientContact: "",
          accountManager: "Manager, Account",
          transferee: "Fox, Indy",
          policyName: "Test",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-13T15:13:51.000Z",
          amount: 0,
          requestDtls: "flight home",
          reason: "He needs to go home",
          currentPolicyAllows: "no flight",
          statusDate: "2024-06-13T15:13:51.000Z",
          expenseType: "Airfare",
          expenseCategory: "Return Trips Home",
          dateCreated: "2024-06-13T15:13:51.000Z",
          osrRecommendations: "do it",
        },
        {
          id: "142",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "test, test",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "SUBMITTED",
          accountManagerResp: "Submitted",
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:35:05.000Z",
          amount: 0,
          requestDtls: "dses",
          reason: "tft",
          currentPolicyAllows: "tdtd",
          statusDate: "2024-06-12T13:35:05.000Z",
          expenseType: "Allowance",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:35:05.000Z",
          osrRecommendations: "tdt",
        },
        {
          id: "141",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "SAVED",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:34:35.000Z",
          amount: 0,
          requestDtls: "tdtdtd",
          reason: "gytfyfy",
          currentPolicyAllows: "yhfyhfy",
          statusDate: "2024-06-12T13:34:35.000Z",
          expenseType: "Allowance",
          expenseCategory: "Final Move",
          dateCreated: "2024-06-12T13:34:35.000Z",
          osrRecommendations: "yfyf",
        },
        {
          id: "140",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:34:04.000Z",
          amount: 0,
          requestDtls: "yrgeyrg",
          reason: "uhgur",
          currentPolicyAllows: "hfuegf",
          statusDate: "2024-06-12T13:34:04.000Z",
          expenseType: "bsnffiv2",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:34:04.000Z",
          osrRecommendations: "jhgur",
        },
        {
          id: "139",
          clientName: "Daniel Michel",
          clientContact: "Melodi, Sania",
          accountManager: "Wills, Jacks",
          transferee: "Mitchel, Marsh",
          policyName: "Demo policy 3",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:33:20.000Z",
          amount: 0,
          requestDtls: "Need more budget",
          reason: "travelling charges",
          currentPolicyAllows: "allow",
          statusDate: "2024-06-12T13:33:20.000Z",
          expenseType: "Allowance",
          expenseCategory: "Final Move",
          dateCreated: "2024-06-12T13:33:20.000Z",
          osrRecommendations: "Yes",
        },
        {
          id: "138",
          clientName: "LNT Enterprises",
          clientContact: "Shak, Shaheel",
          accountManager: "Wills, Jacks",
          transferee: "Test 55, QA",
          policyName: "Adhoc policy",
          status: "REVIEW",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T13:01:22.000Z",
          amount: 0.12334455588966887,
          requestDtls: "need more budget",
          reason: "traveling charges",
          currentPolicyAllows: "Allow",
          statusDate: "2024-06-12T13:01:22.000Z",
          expenseType: "Allowance",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T13:01:22.000Z",
          osrRecommendations: "yes",
        },
        {
          id: "137",
          clientName: "Demo Client",
          clientContact: "Collins, Hannah",
          accountManager: "Demo 112, Testing",
          transferee: "Bolognia, Brock",
          policyName: "Commuter",
          status: "SAVED",
          accountManagerResp: null,
          createdBy: null,
          clientContactResp: "",
          lastUpdated: "2024-06-12T12:27:19.000Z",
          amount: 189,
          requestDtls: "data",
          reason: "test",
          currentPolicyAllows: "test",
          statusDate: "2024-06-12T12:27:19.000Z",
          expenseType: "Inspections (Not in Closing)",
          expenseCategory: "Home Finding",
          dateCreated: "2024-06-12T12:26:58.000Z",
          osrRecommendations: "test",
        },
      ],
      count: 10,
      exceptionStatusList: [
        "PENDING",
        "SAVED",
        "SUBMITTED",
        "APPROVED",
        "DENIED",
        "PROCESSED",
        "HOLD",
        "REVIEW",
      ],
    };
    try {
      const { params, body } = getFilterParamsAndBody(filters);
      const { data }: { data: any } = await axiosClient.post(
        GET_EXCEPTION_REQUEST_REPORT + "?" + params,
        body,
      );
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  public static async exportReports(url: string, filters: any) {
    try {
      const response = await axios.post(url, filters, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (blob) {
        saveAs(blob, "report.xlsx");
      }
    } catch (error) {}
  }

  public static async getFavouriteList(data: any) {
    return axiosClient.get(
      GET_FAVOURITE_LIST + "?" + new URLSearchParams(data).toString(),
    );
  }

  public static async getFavData(filters: any) {
    return await axiosClient.post(GET_FAV_DASHBOARD_DATA, filters);
  }

  public static async vendorTrackingMoveHelp(filters: any) {
    return {
      data: {
        report: {
          vendorTrackingData: [
            {
              vendorTrackingId: "105",
              userId: "5276",
              userFirstName: "Jonny",
              userLastName: "Mawel",
              userFileNumber: "6078-44225",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: null,
              vendorId: "126",
              vendorName: "AltoVita",
              vendorWebsite:
                "https://criclient.altovita.com/landing-page/corporate-relocation-international/802",
              dateAccessed: "2024-06-07T07:54:18.000Z",
              policyId: "331",
              policyName: "Demo Policy1",
              clientId: "209",
              clientName: "Daniel Michel",
              divisionId: "700",
              divisionName: "HR Team",
              consultantId: "1595",
              consultantFirstName: "Amanda",
              consultantLastName: "Yarbrough",
            },
            {
              vendorTrackingId: "104",
              userId: "5213",
              userFirstName: "Steeve",
              userLastName: "Smith",
              userFileNumber: "6078-65373",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: null,
              vendorId: "140",
              vendorName: "SST",
              vendorWebsite: "https://www.reddit.com/?rdt=65460",
              dateAccessed: "2024-06-05T06:37:46.000Z",
              policyId: "331",
              policyName: "Demo Policy1",
              clientId: "209",
              clientName: "Daniel Michel",
              divisionId: "700",
              divisionName: "HR Team",
              consultantId: "3721",
              consultantFirstName: "Angie",
              consultantLastName: "Renteria",
            },
            {
              vendorTrackingId: "103",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "135",
              vendorName: "rfetret",
              vendorWebsite: "dfgfdg.in",
              dateAccessed: "2024-05-28T14:16:05.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "102",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "131",
              vendorName: "xsxaxs",
              vendorWebsite: "ddd",
              dateAccessed: "2024-05-28T14:16:02.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "101",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "128",
              vendorName: "OneSource",
              vendorWebsite:
                "https://osconnects.com/ascensioncorprelo?hsCtaTracking=640d621b-bfcc-43c7-b4e1-1b57a7de94c1%7C67dcbffb-7755-47be-b6e4-38f167bb2c66",
              dateAccessed: "2024-05-28T14:15:55.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "100",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "139",
              vendorName: "test 13 vendor",
              vendorWebsite: "https://www.test.com/",
              dateAccessed: "2024-05-28T14:15:43.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "99",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "134",
              vendorName: "rfetret",
              vendorWebsite: "dfgfdg.in",
              dateAccessed: "2024-05-28T14:15:41.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "98",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "138",
              vendorName: "Penske",
              vendorWebsite:
                "https://www.pensketruckrental.com/rental_entry.html",
              dateAccessed: "2024-05-28T14:15:32.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "97",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "127",
              vendorName: "TRUNK",
              vendorWebsite:
                "https://trunkmoves.com/?sca_ref=1952057.TXJizBQdTp",
              dateAccessed: "2024-05-28T14:15:29.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
            {
              vendorTrackingId: "96",
              userId: "5361",
              userFirstName: "Test ",
              userLastName: "Demo",
              userFileNumber: "4091-4567",
              userEmail: "akshay.p@beyondseek.com",
              userInitiatedDate: "2024-05-28T14:10:58.000Z",
              vendorId: "125",
              vendorName: "TSI",
              vendorWebsite:
                "https://www.tsishipping.com/cri-move-solutions?hsCtaTracking=8dcca037-ace6-4723-aa51-52947b2316d7%7C39ac1a84-82e2-41c9-84e2-e746c948cfff",
              dateAccessed: "2024-05-28T14:15:22.000Z",
              policyId: "377",
              policyName: "SM demo policy 22",
              clientId: "219",
              clientName: "Starley mels",
              divisionId: "717",
              divisionName: "SEI dept",
              consultantId: "5306",
              consultantFirstName: "Malen",
              consultantLastName: "mats",
            },
          ],
          count: 105,
        },
      },
    };
    return await axiosClient.post(VENDOR_TRACKING_MOVE_HELP, filters);
  }
}

export default ReportsService;
